import { render, staticRenderFns } from "./ConfirmDeleteType.vue?vue&type=template&id=0bfcd543"
import script from "./ConfirmDeleteType.vue?vue&type=script&lang=js"
export * from "./ConfirmDeleteType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports